import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Sparkles, X, ArrowRight } from "lucide-react";

/**
 * WhatsNewBanner
 *
 * Quiet, dismissible one-liner that announces a release-note to existing users.
 * Bump WHATS_NEW_KEY (e.g. "tt_whats_new_v2") when you publish the next update,
 * dismissals are scoped per release so the banner reappears once per user per
 * release.
 *
 * Designed to live at the top of the Dashboard, above the "Your cases" header.
 */
const WHATS_NEW_KEY = "tt_whats_new_2026_02_compass";

export default function WhatsNewBanner() {
 const [show, setShow] = useState(false);

 useEffect(() => {
 try {
 if (!localStorage.getItem(WHATS_NEW_KEY)) setShow(true);
 } catch {
 // localStorage disabled. just don't show (safer than nagging)
 }
 }, []);

 const dismiss = () => {
 try {
 localStorage.setItem(WHATS_NEW_KEY, new Date().toISOString());
 } catch {
 /* no-op */
 }
 setShow(false);
 };

 if (!show) return null;

 return (
 <div
 className="mb-6 border border-[#1B6C62]/30 bg-[#E6F5F2]/60 px-4 py-3 flex items-start gap-3 fade-up"
 role="status"
 data-testid="whats-new-banner"
 >
 <div className="w-7 h-7 flex items-center justify-center bg-white border border-[#1B6C62]/40 flex-shrink-0 mt-0.5">
 <Sparkles size={13} strokeWidth={1.75} className="text-[#1B6C62]" />
 </div>
 <div className="flex-1 min-w-0">
 <div className="label-mono mb-0.5 text-[#1B6C62]">What&apos;s new · Feb 2026</div>
 <p className="text-sm font-serif text-[#1A1A1A] leading-snug">
 The AI assistant is now called <span className="font-medium text-[#0D2B52]">Compass</span>,
 same model, clearer name. We also added a{" "}
 <Link to="/guide" className="text-[#1B6C62] underline" data-testid="whats-new-guide-link">
 Help Center
 </Link>{" "}
 with step-by-step answers to common questions.
 </p>
 <Link
 to="/guide"
 className="inline-flex items-center gap-1 mt-1.5 text-xs text-[#0D2B52] hover:text-[#1B6C62]"
 data-testid="whats-new-cta"
 >
 Take a look <ArrowRight size={11} strokeWidth={1.75} />
 </Link>
 </div>
 <button
 onClick={dismiss}
 className="btn-ghost p-1 -mt-0.5 -mr-1 flex-shrink-0"
 title="Dismiss"
 data-testid="whats-new-dismiss"
 >
 <X size={14} strokeWidth={1.5} />
 </button>
 </div>
 );
}
